namespace TabAurous.ProductDevelopment {
    export interface CustomerRequirementForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        PartyCode: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        GstVat: Serenity.StringEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: CustomerRequirementItemsEditor;
        ShipmentId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class CustomerRequirementForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.CustomerRequirement';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerRequirementForm.init)  {
                CustomerRequirementForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = CustomerRequirementItemsEditor;

                Q.initFormType(CustomerRequirementForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'PartyId', w3,
                    'LedgerName', w1,
                    'PartyCode', w1,
                    'Address1', w4,
                    'State', w1,
                    'Country', w1,
                    'TermsId', w2,
                    'UserId', w5,
                    'EmployeeId', w2,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w5,
                    'ExchRate', w6,
                    'GstVat', w1,
                    'ProductItemImage', w7,
                    'ItemDetails', w8,
                    'ShipmentId', w2,
                    'Pieces', w2,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'CCNetAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'GrossAmount', w6,
                    'CCGrossAmount', w6,
                    'Remark', w4,
                    'ShipAddressId', w2,
                    'FinancialYearId', w2,
                    'CompanyId', w2
                ]);
            }
        }
    }
}
